import {CLEAR_AJAX_ERROR_SUBPANELS} from '../../constants';

export type ClearAjaxErrorForSubpanelsAction = {
    /**
     * The action type
     */
    type : typeof CLEAR_AJAX_ERROR_SUBPANELS;

    /**
     * The uid of the component the requests belongs to
     */
    componentUid : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} componentUid         The uid of the component the requests belongs to
 *
 * @return {ClearAjaxErrorForSubpanelsAction}
 */
const clearAjaxErrorForSubpanels = ( componentUid : string = 'global' ) : ClearAjaxErrorForSubpanelsAction => {
    return {
        type: CLEAR_AJAX_ERROR_SUBPANELS,
        componentUid
    };
}
export type ClearAjaxErrorForSubpanels = typeof clearAjaxErrorForSubpanels;

export default clearAjaxErrorForSubpanels;
